<template>
  <div id="app">

    <!--<Layout></Layout>-->
    <router-view></router-view>
  </div>
</template>

<script>
import Layout from '@/page/layout'
export default {
  name: 'App',
  components: {
    Layout
  }
}
</script>

<style>
  #app{
    height:100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue